export const PORTAL_ID = 'trust-overlay-portal';
